import React from 'react';
import {Modal, Text, Button, Icon} from '@/ui-kits';
import {Icons} from '@/constants';

interface SessionExpirationModalProps {
  open: boolean;
  onClose: () => void;
}

export const SessionExpirationModal: React.FC<SessionExpirationModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="bg-white rounded-xl p-6 sm:p-8 max-w-[400px] sm:max-w-[450px] w-[90%] relative">
      <button
        onClick={onClose}
        className="absolute top-3 right-3 sm:top-4 sm:right-4 p-1 rounded-full hover:bg-gray-100">
        <Icon type="close" className="size-5 sm:size-6" />
      </button>

      <div className="flex flex-col items-center text-center gap-4 sm:gap-6">
        {/* Warning Icon */}
        <div className="flex-shrink-0">
          <img src={Icons.yellow_warning} alt="Warning" className="size-16 sm:size-20" />
        </div>

        {/* Title */}
        <Text variant="heading" className="text-ui_blue !font-FigtreeBold !text-xl sm:!text-2xl">
          Session Expiration Warning
        </Text>

        {/* Message */}
        <Text variant="body" className="text-ui_blue !font-FigtreeRegular !text-sm sm:!text-base leading-relaxed">
          Your session will expire in 1 minute due to inactivity.
        </Text>

        {/* OK Button */}
        <Button
          title="OK"
          variant="primary"
          onClick={onClose}
          className="mt-2 px-8 py-2.5"
        />
      </div>
    </Modal>
  );
};
